import { Suspense } from "react";
import DataLoader from "../../components/FinalMolGrid/ui/dataLoader/DataLoader";
import FormCreator from "../../components/forms/FormCreator";
import { EventQuestionAnswerForm } from "./data/EventQuestionAnswerForm.Data";
import { useRef } from "react";
import { paginationObj } from '../../utils/Constants'
import { EventQuestionAnswerTableConfig } from "./data/EventQuestionAnswerTableConfig";
import FinalMolGrid from "../../components/FinalMolGrid/FinalMolGrid";
import Buttons from "../../components/ui/button/Buttons";
import { useState } from "react";
import { useGetFormQuestionAnswerEventDetailListMutation, useLazyGetAllFormQuestionAnswerListByEventIdQuery } from "../../app/services/EventManagement/EventQuestionAnswer/EventQuestionAnswerApi";
import { useEffect } from "react";
import { saveAs } from 'file-saver';
import { encryptAES } from "../../services/CryptoService";
import SwalAlert from "../../services/swalService/SwalService";

const EventQuestionAnswerList = () => {
  const eventQuestionAnswerRef = useRef();
  const molGridRef = useRef();
  const [dataSource, setDataSource] = useState();
  const [pagination, setPagination] = useState({
    ...paginationObj,
    SearchText: "",
  });
  const { confirm, success, error } = SwalAlert()
  const [getQuestionAnswerList, { isLoading: eventQuestionAnswerListLoading, data: eventQuestionAnswerListData, isSuccess: eventQuestionAnswerListIsSuccess }] = useGetFormQuestionAnswerEventDetailListMutation();
  const [getFormQuestionAnswerByEventId, { isSuccess: getFormQuestionAnswerByEventIdIsSuccess, isLoading: getFormQuestionAnswerByEventIdIsLoading, data: getFormQuestionAnswerByEventIdData }] = useLazyGetAllFormQuestionAnswerListByEventIdQuery();

  // useEffects

  useEffect(() => {
    if (!getFormQuestionAnswerByEventIdIsLoading && getFormQuestionAnswerByEventIdIsSuccess && getFormQuestionAnswerByEventIdData) {
    }
  }, [getFormQuestionAnswerByEventIdIsLoading, getFormQuestionAnswerByEventIdIsSuccess, getFormQuestionAnswerByEventIdData]);

  useEffect(() => {
    if (!eventQuestionAnswerListLoading && eventQuestionAnswerListData && eventQuestionAnswerListIsSuccess) {
      setDataSource(eventQuestionAnswerListData.itemList)
      setPagination(prev => {
        return { ...prev, totalCount: eventQuestionAnswerListData.totalCount }
      });
    }
  }, [eventQuestionAnswerListLoading, eventQuestionAnswerListData, eventQuestionAnswerListIsSuccess]);
  useEffect(() => {
    getQuestionAnswerListData(pagination);
  }, []);

  const getQuestionAnswerListData = (data) => {
    getQuestionAnswerList(data);
  }
  const handlePageChange = (page) => {
    const { pageNumber, pageSize } = page;
    getQuestionAnswerList({ ...pagination, pageSize: pageSize, pageNo: pageNumber })
  };
  const searchClick = () => {
    let formData = eventQuestionAnswerRef?.current?.getFormData();
    let request = {
      ...paginationObj,
      SearchText: formData?.eventName || null,
    }
    setPagination(prev => { return { ...prev, ...request } });
    getQuestionAnswerList(request);
  };

  const handleDownload = async (dataa) => {
    if (dataa?.booking === "0") {
      error("Booking is not available")
    }
    else {
      try {
        const id = encryptAES(dataa?.eventId);
        const response = await getFormQuestionAnswerByEventId(
          {
            eventId: id,
          }
        );
        if (response && response.data) {
          const { fileData, fileName } = response.data;
          const blob = new Blob([fileData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          saveAs(blob, fileName || 'download.xlsx');
        }
      } catch (error) {
        console.error('Error downloading the file:', error);
      }
    }
  }
  const actionHandler = {
    Download: handleDownload,
  };
  return (<>
    <div>
      <div className="membership-application">
        <div className="form-card">
          <Suspense fallback={<DataLoader />}>
            <div className="">
              <FormCreator
                config={EventQuestionAnswerForm}
                ref={eventQuestionAnswerRef}
                key={false}
              />
              <div className="col-lg-12 btn-sec mt-2">
                <Buttons
                  onClick={searchClick}
                  buttonText={"Search"}
                  buttonTypeClassName="theme-btn btn mt-auto"
                  isLoading={false}
                />
              </div>
            </div>
          </Suspense>
          <div>
            <h5>Total Count : {pagination.totalCount}</h5>
          </div>
          <div className="table-100 mt-4">
            <FinalMolGrid
              ref={molGridRef}
              configuration={EventQuestionAnswerTableConfig}
              dataSource={dataSource}
              isLoading={eventQuestionAnswerListLoading}
              allowPagination={true}
              pagination={pagination}
              onActionChange={actionHandler}
              onPageChange={handlePageChange}
            />
          </div>
        </div>
      </div>
    </div>
  </>)
}
export default EventQuestionAnswerList;